import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-custom-field',
    templateUrl: './custom-field.component.html',
    styleUrls: ['./custom-field.component.scss'],
})
export class CustomFieldComponent implements OnInit {
    selectedIndex = 0;

    constructor() {}

    ngOnInit(): void {}

    updateSelectedIndex(index: number) {}
}
